import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import youngraechoImage from '../images/youngraecho.jpg';
import jonghoonImage from '../images/jonghoon.jpg';
import gwanghyeonImage from '../images/gwanghyeon.jpg';
import heeyeonImage from '../images/heeyeon.png';
import isuImage from '../images/isu.jpg';
import jaewooImage from '../images/jaewoo.jpg';
import jungsuImage from '../images/jungsu.jpg';
import sangpilImage from '../images/sangpil.jpg';
import yoonbeeImage from '../images/yoonbee.jpg';
import wooseokImage from '../images/wooseok.jpg';
import minsuImage from '../images/minsu.jpg'

const membersData = {
  "Faculty": [
    {
      name: "Prof. Young-Rae Cho",
      title: "Principal Investigator",
      image: youngraechoImage,
      affiliation: "Division of Software, Division of Digital Healthcare, Yonsei University-Mirae Campus",
      email: "youngcho@yonsei.ac.kr",
      office: "328 Changjo-hall",
      tel: "+82-33-760-2245",
      homepage: "https://ads.yonsei.ac.kr/faculty"
    },
  ],
  "Ph.D. Students": [
    {
      name: "Jong-Hoon Park",
      title: "Ph.D. Candidate",
      image: jonghoonImage,
      researchInterest: "Data Mining, Machine Learning",
      email: "jonghoon_park@yonsei.ac.kr"
    },
    {
      name: "Gwang-Hyeon Yun",
      title: "Ph. D. Student",
      image: gwanghyeonImage,
      researchInterest: "Deep Learning, Artificial Intelligent",
      email: "ghyun0130@yonsei.ac.kr"
    },
  ],
  "M.S. Students": [
    {
      name: "Sang-Pil Cho",
      title: "M.S. Course",
      image: sangpilImage,
      researchInterest: "Bioinformatics, Machine Learning",
      email: "s.p.cho@yonsei.ac.kr"
    },
    {
      name: "Hee-Yeon Jo",
      title: "M.S. Course",
      image: heeyeonImage,
      researchInterest: "Bioinformatics, Artificial Intelligence",
      email: "hy7531@yonsei.ac.kr"
    },        
    {
      name: "Minsu Joo",
      title: "M.S. Course",
      image: minsuImage,
      researchInterest: "Bioinformatics, Machine Learning",
      email: "jopulation@yonsei.ac.kr"
    },        
  ],
  "Undergraduates": [
    {
      name: "Woo-Seok Wang",
      title: "Undergraduate",
      image: wooseokImage,
      researchInterest: "Bioinformatics, Machine Learning",
      email: "wangws1108@yonsei.ac.kr"
    },
  ],
  "Alumni": [
    {
      name: "Yi-Sue Jung",
      title: "M.S. (2023)",
      image: isuImage,
      email: "yisue@yonsei.ac.kr",
      currentPosition: ""
    },
    {
      name: "Yoonbee Kim",
      title: "M.S. (2023)",
      image: yoonbeeImage,
      email: "yoonbee7@yonsei.ac.kr",
      currentPosition: "Mogam Institute for Biomedical Research"
    },
    {
      name: "Jung-Su An",
      title: "M.S. (2024)",
      image: jungsuImage,
      email: "bulebed1754@yonsei.ac.kr",
      currentPosition: "QUVE Seventeen"
    },    
    {
      name: "Jae-Woo Chu",
      title: "M.S. (2026)",
      image: jaewooImage,
      email: "chu0206@yonsei.ac.kr",
      currentPosition: "(주)바스젠바이오"
    },
  ],
};

const Members: React.FC = () => {
  const facultyMember = membersData.Faculty[0]; // PI는 한 명이라고 가정

  return (
    <Container>
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom textAlign="center" sx={{ fontWeight: 'bold' }}>
          Our Members
        </Typography>
        <Typography variant="body1" textAlign="center" sx={{ mb: 6 }}>
          Meet the dedicated team behind the Advanced Data Science Lab.
        </Typography>
      </Box>

      {/* PI Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Principal Investigator
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          <Box sx={{ flex: '1 1 100%' }}>
            <Paper elevation={3} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, position: 'relative', pt: { xs: 3, sm: 3 }, pr: { xs: 3, sm: 10 }, pb: 3, pl: 3 }}>
              <Box sx={{
                flexShrink: 0,
                width: { xs: '100%', sm: 200 },
                alignSelf: 'stretch',
                backgroundImage: `url(${facultyMember.image})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                minHeight: { xs: 200, sm: 'auto' },
                mr: { sm: 2 }
              }} />
              <Box sx={{ flexGrow: 1, textAlign: { xs: 'center', sm: 'left' } }}>
                <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {facultyMember.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
                  {facultyMember.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Affiliation:</strong> {facultyMember.affiliation}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Email:</strong> {facultyMember.email}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Office:</strong> {facultyMember.office}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Tel:</strong> {facultyMember.tel}
                </Typography>
              </Box>
              <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
                <Button 
                  variant="contained" 
                  href={facultyMember.homepage} 
                  target="_blank" 
                  startIcon={<LinkIcon />}
                  size="small"
                >
                  Homepage
                </Button>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>

      {/* Other Members Sections */}
      {(Object.keys(membersData) as (keyof typeof membersData)[]).filter(group => group !== "Faculty").map((group) => (
        <Box key={group} sx={{ mb: 6 }}>
          <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {group}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {membersData[group].map((member, index) => (
              <Box key={index} sx={{ flex: { xs: '1 1 100%', sm: '0 0 calc(50% - 16px)' } }}>
                <Paper elevation={3} sx={{ display: 'flex', flexDirection: 'row', height: '100%', overflow: 'hidden' }}>
                  <Box sx={{ flex: '0 0 150px', height: 'auto' }}>
                    <img alt={member.name} src={member.image} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </Box>
                  <Box sx={{ flex: '1 1 auto', p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {member.name}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
                      {member.title}
                    </Typography>
                    {group === "Ph.D. Students" || group === "M.S. Students" || group === "Undergraduates" ? (
                      <React.Fragment>
                        <Typography variant="body2">
                          <strong>Research Interest:</strong> {(member as { researchInterest: string }).researchInterest}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Email:</strong> {(member as { email: string }).email}
                        </Typography>
                      </React.Fragment>
                    ) : group === "Alumni" ? (
                      <React.Fragment>
                        <Typography variant="body2">
                          <strong>Current Position:</strong> {(member as { currentPosition: string }).currentPosition}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Email:</strong> {(member as { email: string }).email}
                        </Typography>
                      </React.Fragment>
                    ) : null}
                  </Box>
                </Paper>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Container>
  );
};

export default Members;
